<template>
  <div>
    <template
      v-if="isDeveloper">
      Ключ карты критериев: {{ tenderMutable.criteryCard }}
    </template>
    <slot name="title"/>
    <ModalFullScreen
      v-model="dialog"
      fullscreen
      no-click-animation
      persistent>
      <EditCriteriaCard
        ref="editCriteriaCard"
        :dialog.sync="dialog"
        :tender.sync="tenderMutable"
        @backStep="$emit('backStep')"
        @finish="editCard"
        @nextStep="$emit('nextStep')"/>
    </ModalFullScreen>
    <div class="pt-5 pb-2 flex flex-between align-center">
      <sTooltip
        class="item"
        content="Редагування картки критеріїв заборонено адміністратором компанії"
        :disabled="!isLocked"
        placement="top">
        <sButton
          class="h11-links-bold px-2"
          data-qa="create-new-card"
          :disabled="isLocked"
          icon="plus"
          icon-size="10px"
          small
          type="text"
          @click="createNewCard">
          {{ $t('Tenders.CreateNewCriteriaCard') }}
        </sButton>
      </sTooltip>
      <CriteriaCardsTemplate
        :is-locked="isLocked"
        :open-editing="editCard"
        :tender.sync="tenderMutable"
        @finish="$emit('nextStep')"/>
    </div>
    <div class="pt-1 px-1">
      <sIcon
        v-if="loading"
        class="my-5"
        color="var(--white-color)"
        size="30"
        spin
        type="loading"/>
      <template v-for="(item, n) in cards">
        <div
          :key="`switch-${n}`"
          class="flex">
          <sTooltip
            class="item"
            content="Редагування картки критеріїв заборонено адміністратором компанії"
            :disabled="!isLocked"
            placement="top">
            <sSwitch
              class="my-auto ml-3"
              color="var(--black-color)"
              :disabled="isLocked"
              :true-value="item.code"
              :value.sync="currentCardCode"/>
          </sTooltip>
          <span
            class="h5-headline ml-1"
            :class="(tenderMutable.criteryCard === item.code ? '': 'light_') + 'black--text'"> {{ $t('Common.Use') }}</span>
        </div>
        <CriterionCard
          :key="`card-${n}`"
          :bidding_type="tenderMutable.biddingType"
          blur_unselected
          :is_selected="tenderMutable.criteryCard === item.code"
          :item="item"
          :locked="isLocked"
          :open-editing="editCard"
          :tender="tenderMutable"/>
      </template>
      <sModal
        :closable="false"
        :mask-closable="false"
        :title="$t('Tenders.SureWthoutCriteria')"
        :value="showConfirmationDialog">
        {{ $t('Tenders.SuppliersWIndicateOnlyPrice') }}
        <div
          key="footer"
          slot="footer">
          <sButton
            data-qa="btn-continue"
            @click="nextFunc">
            {{ $t('Tenders.Continue') }}
          </sButton>
          <sButton
            class="ml-2"
            data-qa="btn-dialog-template-second"
            type="text"
            @click="showConfirmationDialog = false">
            {{ $t('Common.Cancel') }}
          </sButton>
        </div>
      </sModal>
    </div>
  </div>
</template>
<script>
import EditCriteriaCard from 'pages/tender creation/EditCreteriaCard.vue'
import CriterionCard from 'components/tenders/critetia/CriterionCard.vue'
import CriteriaCardsTemplate from 'components/tenders/critetia/CriteriaCardsTemplate.vue'

import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

import { eventBus } from '@/main'

import ModalFullScreen from 'components/common/elements/ModalFullScreen.vue'

import editTenderMixin from 'mixins/editTenderMixin'

export default {
  name: 'TenderCriteria',
  mixins: [editTenderMixin],
  data() {
    return {
      used_cards: [],
      cards: [],
      loading: false,
      dialog: false,
      showConfirmationDialog: false,
      propsConfirmationDialog: {}
    }
  },
  methods: {
    /**
     * Вызывается перед переходом на следующий шаг
     */
    beforeNextStep(props) {
      if (!this.currentCardCode) {
        this.showConfirmationDialog = true
        this.propsConfirmationDialog = props
        return false
      }
      return true
    },
    nextFunc() {
      this.showConfirmationDialog = false
      this.$root.$emit('setAccessNextStep', this.propsConfirmationDialog)
    },
    openDialog() {
      this.$nextTick(() => {
        this.$refs.editCriteriaCard?.setCard()
        this.dialog = true
      })
    },
    createNewCard() {
      this.currentCardCode = null
      this.openDialog()
    },
    checkChages() {
      return this.tenderMutable?.criteryCard !== 0 && this.tenderMutable?.criteryCard != this.tenderMutable?.default?.criteryCard
    },
    async editCard(code) {
      if (this.tenderMutable.criteryCard === code) {
        if (this.checkChages()) {
          this.$root.$emit('showOverlay')
          this.mixin_checkTenderBySettings(this.tenderMutable)
          if (this.$_initializeLotGroups) {
            this.$_initializeLotGroups(this.tenderMutable)
          }
          await api.editTenderDraft(this.tenderMutable)
            .then(() => {
              this.openDialog()
            })
            .catch((error) => {
              eventBus.$emit('showErrorSnackbar', error)
              return
            })
            .finally(() => this.$root.$emit('closeOverlay'))
        }
      } else {
        this.currentCardCode = code
      }
    },
  },
  computed: {
    isLocked() {
      return !this.$acl.check('tenderAdmin') && this.cards?.find(card => card.code == this.currentCardCode)?.isLocked == 'LOCKED'
    },
    tenderMutable: {
      get() {
        return this.tender
      },
      set(newValue) {
        this.$emit('update:tender', newValue)
      }
    },
    currentCardCode: {
      get() {
        return this.tenderMutable.criteryCard
      },
      set(newValue) {
        newValue = newValue || null
        if (this.tenderMutable.criteryCard != newValue) {
          const result = this.$_.cloneDeep(this.tenderMutable)
          result.criteryCard = newValue
          this.tenderMutable = result
        }
      }
    },
  },
  components: {
    CriterionCard,
    ModalFullScreen,
    EditCriteriaCard,
    CriteriaCardsTemplate
  },
  async created() {
    this.loading = true
    const cards = await this.$store.dispatch('setAvailableCards', this.tender.tenderId)

    this.cards = cards.map(item => {
      item.name = item.criterionCardType === 'STANDARD' ? this.$t('Tenders.StandardSetCriteria') : item.name
      return item
    })
    this.loading = false
  },
  props: {
    tender: {
      type: Object
    },
    rules: {
      type: Object
    }
  },
}
</script>
